import { Component, OnInit } from '@angular/core';
import { RoleService } from '../../service/role/role.service';
import { Role } from '../../class/role';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public roles: Role[];
    public selectRole: Role;
    public userID: Number = 0;
    public modNew = false;
    public modView = false;
    public openRole = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public roleService: RoleService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        //this.getRoles();
        this.page = 1;
        this.per_page = 10;
    }

    public loadRolesLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getRoles(event.globalFilter);
    }

    public getRoles(query?: string) {
        this.roleService.getRole(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.roles = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newRole() {
        this.modNew = !this.modNew;
        this.selectRole = null;
    }

    public savedRole(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectRole = null;
        this.modNew = false;
        this.getRoles();
    }

    public cancelRole (res) {
        this.selectRole = null;
        this.modNew = false;
        this.modView = false;
        this.getRoles();
    }

    public edit(user: Role) {
        this.modNew = true;
        this.selectRole = user;
        this.getRoles();
    }

    public view(user: Role) {
        this.openRole = true;
        this.selectRole = user;
        this.userID = user.id;
        this.modView = true;
    }

    public deleteDialog(user: Role) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(user);
            }
        });
    }

    public delete(user: Role) {
        this.roleService.deleteRole(user.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getRoles();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeRole(user: Role) {
        this.putRole(user);
    }

    public putRole(values: Role) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.roleService.updateRole(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/roles/roles.component.ts